<template>
  <svg class="icon" :class="`icon-${icon}`">
    <use :xlink:href="`${svgSpriteSrc}#${icon}`" />
  </svg>
</template>

<script>
  export default {
    name: 'SVGIcon',
    data() {
      return {
        svgSpriteSrc: ''
      }
    },
    mounted() {
      this.svgSpriteSrc = document.getElementById('svg-sprite').getAttribute('src')
    },
    props: {
      icon: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .icon-contacts,
  .icon-news,
  .icon-appeals,
  .icon-payment,
  .icon-counters,
  .icon-dispatcher {
    width: 20px;
    height: 20px;
  }
</style>
